<template>
  <div class="wrap">
    <div class="content">
      <base-header :name="user_name" :topOnly="flag_top" :account_list="account_list"></base-header>
<!--      <div class="main_time"></div>-->
      <div :class="'plus-box '+(plus_flag?'over':'get')" @click="open_dialog('bh')"></div>
      <div class="zuanpan"  @click="open_turn_pop()">
          <div class="zpjh">本周转盘机会：<span>{{turn_remain}}次</span></div>
          <div :class="['sjdl',turn_remain > 0 ? '':'sjdlnone']"></div>
      </div>
            <div class="part part1">
                <div class="title"></div>
                <div class="titleText">
                    <span style="margin-right: 4px;">{{total_exploit}}</span>赛季经验待领取
                    <div class="blBtn" v-show="total_exploit>0" @click="open_dialog('yc')"></div>
                </div>
                <div class="taskContent">
                    <div class="task task1">
                        <div :class="['taskTip task1Tip', selectTip == 1 ? 'taskTipactive' : '']" @click="selectTip == 1 ? selectTip = -1 : selectTip = 1">
                            <div class="task1img" v-show="selectTip == 1"></div>
                        </div>
                        <div class="taskTitle">
                            赛季段位到达<span>{{ cpName || '大师'}}<br /></span>或场次到达<span>{{cpCount || 10}}场</span>
                        </div>
                        <div class="taskcp">
                            <div class="taskt">当前段位</div>
                            <div class="taskc">{{score.name || '精英'}}</div>
                        </div>
                        <div class="taskcp">
                            <div class="taskt">当前场次</div>
                            <div class="taskc">{{my_win_count || 0}}场</div>
                        </div>
                        <div class="taskjy">
                            <p class="taskimgtext">
                                X{{my_danGrading_data ?
                                my_danGrading_data.packet_name.slice(0, -4) : 400}}
                            </p>
                        </div>
                        <div :class="['taskbtn', have_pcg ? my_danGrading_balance ? 'get' : 'over' : '']"
                            @click="get_danGrading_award()"></div>
                    </div>
                    <div class="task task2">
                        <div :class="['taskTip task2Tip', selectTip == 2 ? 'taskTipactive' : '']" @click="selectTip == 2 ? selectTip = -1 : selectTip = 2">
                            <div class="task2img" v-show="selectTip == 2"></div>
                        </div>
                        <div class="taskTitle">
                            击杀达到<span>{{kill_baseData?kill_baseData.total_step:0}}</span>
                        </div>
                        <div class="taskcp">
                            <div class="taskt">当前击杀</div>
                            <div class="taskc">
                               {{kill_over_step}}/{{kill_baseData?kill_baseData.total_step:0}}
                            </div>
                        </div>
                        <div class="taskjy">
                            <p class="taskimgtext">
                                X{{cpkillScore}}
                            </p>
                        </div>
                        <div :class="['taskbtn taskbtn2',kill_baseData ? kill_baseData.cn : '']"
                            @click="get_task(kill_baseData,2)"></div>
                    </div>
                    <div class="task task3">
                        <div :class="['taskTip task3Tip', selectTip == 3 ? 'taskTipactive' : '']" @click="selectTip == 3 ? selectTip = -1 : selectTip = 3">
                            <div class="task3img" v-show="selectTip == 3"></div>
                        </div>
                        <div class="taskTitle">累计登录平台<span>5天</span></div>
                        <div class="taskcp">
                            <div class="taskt">本周已登录</div>
                            <div class="taskc">{{login_count}}/5天</div>
                        </div>
                        <div class="taskjy">
                            <p class="taskimgtext">
                                X150
                            </p>
                        </div>
                        <div :class="['taskbtn',weekLoginList ? weekLoginList.cn : '']"
                            @click="get_packet(weekLoginList)"></div>
                    </div>
                    <div class="task task4">
                        <div :class="['taskTip task4Tip', selectTip == 4 ? 'taskTipactive' : '']" @click="selectTip == 4 ? selectTip = -1 : selectTip = 4">
                            <div class="task4img" v-show="selectTip == 4"></div>
                        </div>
                        <div class="taskTitle">酒币开<span>10次单人挑战</span></div>
                        <div class="taskcp">
                            <div class="taskt">本周已开</div>
                            <div class="taskc">{{win_over_step}}/10次</div>
                        </div>
                        <div :class="plus_flag ? 'taskjyp' : 'taskjylock'" @click="open_dialog('bh')">
                            <p class="taskimgtext">
                                X100
                            </p>
                        </div>
                        <div v-if="!plus_flag" class="kplus" @click="open_dialog('bh')"></div>
                        <div v-else :class="['taskbtn taskbtn1',dan10p_status]" @click="get_plus_task(dan10p_data , 4)">
                        </div>
                        <div class="taskjy">
                            <p class="taskimgtext">
                                X100
                            </p>
                        </div>
                        <div :class="['taskbtn taskbtn2',dan10_status]" @click="get_task(dan10_data,4)"></div>
                    </div>
                    <div class="task task5">
                        <div :class="['taskTip task5Tip', selectTip == 5 ? 'taskTipactive' : '']" @click="selectTip == 5 ? selectTip = -1 : selectTip = 5">
                            <div class="task5img" v-show="selectTip == 5"></div>
                        </div>
                        <div class="taskTitle">酒币开<span>3次连胜挑战</span></div>
                        <div class="taskcp">
                            <div class="taskt">本周已开</div>
                            <div class="taskc">{{win2_over_step}}/3次</div>
                        </div>
                        <div :class="plus_flag ? 'taskjyp' : 'taskjylock'" @click="open_dialog('bh')">
                            <p class="taskimgtext">
                                X150
                            </p>
                        </div>
                        <div v-if="!plus_flag" class="kplus" @click="open_dialog('bh')"></div>
                        <div v-else :class="['taskbtn taskbtn1',lian3p_status]" @click="get_plus_task(lian3p_data , 5)">
                        </div>
                        <div class="taskjy">
                            <p class="taskimgtext">
                                X150
                            </p>
                        </div>
                        <div :class="['taskbtn taskbtn2',lian3_status]" @click="get_task(lian3_data,5)"></div>
                    </div>
                    <div class="task task6">
                        <div :class="['taskTip task6Tip', selectTip == 6 ? 'taskTipactive' : '']" @click="selectTip == 6 ? selectTip = -1 : selectTip = 6">
                            <div class="task6img" v-show="selectTip == 6"></div>
                        </div>
                        <div class="taskTitle">赛季胜利<span>10场</span></div>
                        <div class="taskcp">
                            <div class="taskt">本周已胜利</div>
                            <div class="taskc">{{win3_over_step}}/10场</div>
                        </div>
                        <div :class="plus_flag ? 'taskjyp' : 'taskjylock'" @click="open_dialog('bh')">
                            <p class="taskimgtext">
                                X150
                            </p>
                        </div>
                        <div v-if="!plus_flag" class="kplus" @click="open_dialog('bh')"></div>
                        <div v-else :class="['taskbtn taskbtn1',ying10p_status]" @click="get_plus_task(ying10p_data,6)">
                        </div>
                    </div>
                </div>
                <div ref="bottomRef" :class="{'down': true,'active': isActive}"></div>
                <!-- <div class="zuanpan">
                    <div class="zpjh">本周转盘机会：<span>{{turn_remain}}次</span></div>
                    <div class="sjdl" @click="open_dialog('gzh')"></div>
                </div> -->
            </div>
            <div class="part part2">
                <div class="title"></div>
                <div class="titleText">赛季经验仅限本赛季有效，请及时领取奖励</div>
                <div class="p2jy"><div class="p2text">我的经验：<span>{{add_exploit_count || 0}}</span></div></div>
                <div class="jfContent">
                    <div class="p2line"></div>
                    <div :class="'jfItem jfItem'+d" v-for="(i,d) in add_exploit_baseData" :key="i.packet_id">
                        <!-- 积分 -->
                        <div v-if="i.packet_id != 920241" class="jfscore">{{i.count}}</div>
                        <div v-else class="jfscoreL">
                        </div>
                        <!-- 框 -->
                        <div v-if="i.packet_id == 920241" class="jfkc"></div>
                        <div v-else-if="i.use_flag == 4" class="jfkp"></div>
                        <div v-else class="jfk"></div>
                        <!-- 图片 -->
                        <img class="packetImg" :src="'https://cdn.09game.com/resources/item/dj_'+i.s[0].id+'_200.png'"
                            :title="i.packet_name" alt="" />
                        <i class="icon-play" v-if="i.s&&i.s[0].id>1000&&i.s[0].count==-1"
                            @click="open_dialog('prev',i.s)"></i>
                        <!-- plus -->
                        <div v-if="i.use_flag==4 && !plus_flag" class="plusLock"></div>
                        <!-- tips -->
                         <div v-if="i.packet_id == 920241" class="lstTip"  @click="showlastTip = !showlastTip">
                            <div v-show="showlastTip" class="jfcTip"></div>
                         </div>
                        <!-- 文字 -->
                        <div v-if="i.packet_id != 920241"
                            :class="['jfkname', i.packet_id == 920234 ? 'hj' : i.packet_id == 920236 ? 'xy' : i.packet_id == 920238 ? 'bx' : i.packet_id == 920240 ? 'zb' : '']">
                            {{i.packet_name}}</div>
                        <div v-if="i.packet_id == 920241" class="lstTimes">可领取：{{last_count}}次</div>

                        <!-- 按钮 -->
                        <div :class="`p2btn ${last_count > 0 ? 'get': ''}`" @click="get_add_award(i,d)"
                            v-if="i.packet_id === 920241"></div>
                        <div :class="`p2btn ${is_plus_task(i.packet_id) && !plus_flag ? 'btn-plus': i.cn}`"
                            @click="get_add_award(i,d)" v-else></div>
                        <!-- 段位 -->
                        <div class="duanWeiTips"
                            v-if="i.packet_id == 920234 ||i.packet_id == 920236||i.packet_id == 920238||i.packet_id == 920240">
                            超凡至尊{{i.packet_id == 920234?'Ⅲ':i.packet_id == 920236?'Ⅳ':i.packet_id ==
                            920238?'Ⅴ':'Ⅵ'}}可直接领取
                        </div>
                    </div>
                </div>
            </div>
            <div class="part part3">
                <div class="title"></div>
                <div class="titleText">赛季福利点数仅在当前赛季有效，赛季结束后清空，请尽快兑换</div>
                <div class="p3fl"><div class="p3text">我的福利点：<span>{{present_exploit_count || 0}}</span></div></div>
                <div class="p3c">
                    <div :class="'p3Item p3Item'+d" v-for="(i,d) in present_exploit_baseData" :key="i.packet_id">
                        <div class="p3Itemtop" v-if="i.packet_id != 920246 && i.packet_id != 920247">
                            <img class="p3packetImg"
                                :src="'https://cdn.09game.com/resources/item/dj_'+i.s[0].id+'_200.png'"
                                :title="i.packet_name" alt="" />
                            <div class="p3packetname">{{i.packet_name}}</div>
                            <div class="p3fldnum">
                                <img src="~@/assets/img/s34/fldicon.png" />
                                <span>{{i.count}}</span>
                                福利点
                            </div>
                            <div :class="'p3btn '+(i.have?'over':i.count <= present_exploit_count?'get':'')"
                                @click="throttledHandler(i,d,1)"></div>
                        </div>
                        <div class="p3Itembot" v-else>
                            <div class="p3icon p3icon1" v-if="i.packet_id == 920246"></div>
                            <div class="p3icon p3icon2" v-else-if="i.packet_id == 920247"></div>
                            <img class="p3packetImg"
                                :src="'https://cdn.09game.com/resources/item/dj_'+i.s[0].id+'_200.png'"
                                :title="i.packet_name" alt="" />
                            <div class="p3packetname">{{i.packet_name}}</div>
                            <div class="p3fldnum">
                                <img src="~@/assets/img/s34/fldicon.png" />
                                <span>{{i.count}}</span>
                                福利点
                            </div>
                            <div :class="'p3btn '+(i.have?'over':i.count <= present_exploit_count?'get':'')"
                                @click="throttledHandler(i,d,2)"></div>
                        </div>
                    </div>
                    <div class="p3lastdh">
                        <img class="p3packetImg" src="~@/assets/img/s34/sp2hero.png"
                            title="SP2英雄自选*90天" alt="" />
                        <div :class="'p3btn '+(3199 <= present_exploit_count?'get':'')" @click="selectSp2Hero()"></div>
                        <div class="imgContent">
                            <div class="imgc" v-for="(i,d) in zx_heroBaseData" :title="i.name" :key="i.item_id">
                                <img :src="'https://cdn.09game.com/resources/item/dj_'+i.item_id+'_200.png'" alt=""
                                    :title="i.item_name" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="banner_tips">
                注：本活动仅针对DOTA、IM、OMG、DS大随（其他RPG无法完成任务及获得奖励）
            </div>
      <div class="mate-info"></div>
      <!-- <div class="mate-info2"></div> -->
    </div>
        <div :class="['pop', p_s == 'bh' ? 'bhc' : p_s=='c_reward' ? 'c_reward' : p_s=='l_reward' ? 'l_reward' : p_s=='gzh' ? 'gzh' : p_s=='yc' ? 'yc' : p_s=='prev' ? 'prev' : p_s=='turn' ? 'turn':'']"
            v-if="p_s">
            <div class="tite">
                {{p_s=='bh'?'':p_s=='gzh'?'只能在微信公众号领取或兑换':p_s=='yc'?'补领提示':p_s=='prev'?videoName:p_s=='l_reward'?'幸运抽奖':p_s=='turn' ? '':'请选择兑换的奖励'}}
                <div class="close" @click="close_pop()"></div>
            </div>
            <div class="inner" v-if="p_s!='prev'&&p_s!='c_reward'&&p_s!='l_reward'&&p_s!='turn'">
                <div v-if="p_s=='bh'" class="bh">
                    <p v-if="!plus_flag">
                        你将消耗 <br><span class="bhjb">490酒币</span><br>开启平台Plus<span>*30天</span>
                    </p>
                    <p v-else style="height: 1rem; line-height: 0.5rem;">平台Plus已开通 (剩余 <span>{{shengxia}}</span>天)<br><span>重新登录后生效</span></p>
                    <!-- <div>
                        >> 开启平台Plus专属任务<br />
                        >> 游戏内净化言论环境权利 <br />
                        >> 游戏内打赏玩家权利 <br />
                        >>
                        酷炫顶标【闭麦听歌一V五】【野见愁】【节奏大师】【辅助小可爱】*30天<br />
                        >>
                        每日赛季首胜获得300酒豆+Plus2点经验（酒豆有效期1天，我的福利领取）<br />
                        >> 每月15日24点获得1000赛季经验+平台喇叭*1 <br />
                        >> 更多福利特权详情见平台Plus专区
                    </div> -->
                </div>
                <div v-if="p_s=='yc'" class="yc">
                    <div style="height: 137px">
                    <div class="money-mate">
                        将消耗 <br><span class="ycjb">{{Math.ceil(c_f/2)}}酒币</span> <br>补领
                        <span>{{c_f}}</span>赛季经验
                    </div>
                        <div class="num">
                            <em class="left">0</em> <em class="right">{{total_exploit}}</em>
                            <div class="bar">
                                <div class="bar-block" :style="'width:'+slider.width+'%'">
                                    <div class="drag" @touchstart.stop="touchstart" @touchmove.stop="touchmove" @touchend.stop="touchend">
                                        <em class="choose" v-if="c_f!=0 && c_f !=total_exploit">{{c_f}}</em>
                                        <div><span class="ycq"></span></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <!-- <div class="gzh" v-if="p_s=='gzh'">
                    <div class="code">
                        <img src="./img/wcode.jpg" alt="" />
                    </div>
                    <p>扫码关注</p>
                </div> -->

                <div class="btns">
                    <ul v-if="p_s=='yc'">
                        <li class="sure popbtn" @click="confirm_retroactive()"></li>
                        <!-- <li class="cancle" @click="close_pop()"></li> -->
                    </ul>
                    <ul v-if="p_s=='bh'">
                        <li class="buy popbtn" v-if="!plus_flag" @click="open_membership()"></li>
                        <li v-else class="sure popbtn" @click="close_pop()"></li>
                    </ul>
                    <ul v-if="p_s=='gzh'">
                        <li class="sure popbtn" @click="close_pop()"></li>
                    </ul>
                </div>
            </div>

            <div v-else :class="'inner '+p_s">
                <div v-if="p_s=='prev'" style="width: 100%; height: 100%">
                  <video :src="videoUrl" style="
                    display: block;
                    width: 4.92rem;
                    height: 2.77rem;
                    margin: 0 auto;
                    margin-top: 0.3rem;
                    background: #000000;
                  " autoplay width="4.92rem" height="2.77rem;" loop></video>
                </div>
                <div v-if="p_s=='c_reward'">
                    <ul class="list" v-if="zx_heroBaseData.length > 0">
                        <li  v-for="(i,d) in zx_heroBaseData" :title="i.name" :key="i.item_id">
                            <div class="imgc" :class="choo_id==i.item_id?'active':''" @click="chooId(i,d)">
                                <img :src="'https://cdn.09game.com/resources/item/dj_'+i.item_id+'_200.png'" alt=""
                                    :title="i.item_name" />
                            </div>

                            <p>{{i.item_name}}</p>
                            <p v-if="i.id!=0" :style="{ color: (i.h_amount > 0 ? '#FF814B' : '#D4B3A6')}">
                                {{i.h_amount>0?(i.h_amount>=2000?'已拥有':'拥有'+i.h_amount+'天'):'未拥有'}}</p>

                        </li>
                    </ul>

                    <div class="list" v-else>
                        <p style="
                            padding-top: 0;
                            color: #D4B3A6;
                            font-size: 16px;
                        ">
                            请点击左上方的“刷新”随机首批可兑换奖励
                        </p>
                    </div>
                    <div :class="['btnSx',!sxSp2heroStatus?'get':'no']" @click="sx_sp2Hero()"></div>
                    <div class="tips" @click="showspTip = !showspTip">
                        <div class="tips_inner" v-show="showspTip">每月可手动刷新1次，不可累计</div>
                    </div>
                    <div class="btn ghrbtn" v-if="zx_heroBaseData.length > 0" @click="confirm_zxHero()"></div>
                    <div class="btn ghrbtn" v-else @click="close_pop()"></div>
                </div>
                <!-- 转盘抽奖 -->
                <div v-if="p_s=='turn'">
                  <LuckyWheel ref="myLucky" class="myLucky-box" :width="width" :height="height" :prizes="prizes" :blocks="blocks" :buttons="buttons" @start="startCallback" @end="endCallback" />
                  <div class="num">
                    转盘机会：
                    <span>{{turn_remain}}</span>次
                  </div>
                  <div :class="['btn', turn_remain?'get':'']" @click="startCallback()"></div>
                </div>
            </div>
        </div>

    <div class="mark" v-if="p_s" @touchmove.prevent ></div>
    <div class="tipmark" v-if="selectTip != -1 || showlastTip" @click="selectTip=-1 ; showlastTip=false"></div>
  </div>
</template>
<script>
import dotaSeason from '@/assets/js/s27/seasondan.js'
import $09game from '@/assets/js/s27/taskplugin'
import {
  q_cfg_packet,
  q_cfg_item,
  q_cfg_task,
  q_my_task,
  q_my_packet,
  use_packet,
  q_my_packet_use,
  q_my_item,
  q_cfg_list,
  q_single,
  buy_goods,
  q_cfg_goods,
  use_item,
  q_my_item_amount,
  isToday,
  getMaxSort,
  formatYearMonth,
  isCurrentMonth,
  compareTime,
  query_time,
  GetDateStr,
  closeWindow,
} from '@/assets/js/s27/controller.js'
import { baseUrls } from '@/utils/baseUrlConfig'
const base_url = baseUrls.user_url

var now = new Date().setHours(0, 0, 1, 0)
var today = new Date(now).getDay()

today = today == 0 ? 7 : today

var w_b = new Date(GetDateStr(-(today - 1), now)).setHours(0, 0, 1, 0)
var w_e = new Date(GetDateStr(7 - today, now)).setHours(0, 0, 1, 0)

var w_u = 'https://hd.09game.com/s34diancang'; //正式
// w_u = 'http://192.168.1.148:5073' //注释
var mouse,
  _09game = null

export default {
  name: 's34',
  data() {
    return {
      token: this.$storage.getToken(),
      isActive: false,
      btn_clock:0,
      user_name: '',
      account_list: [],
      flag_top: true,
      payData: {},
      pay_jiubi: 0,
      app_id: 92020, //需要修改
      lsi: 92020, //需要修改
      selectTip:-1,
      showlastTip:false,
      showspTip:false,
      user_id: '',
      d_t: [],
      d_t_list: [],
      // 随机英雄
      hero_arr: [], //基本数据数组
      hero_over_step: 0, //更新over_step
      hero_baseData: {}, //该任务对应数据（packet_id和按钮状态）
      hero_baseStatus: '',
      radom_hero: '', //随机英雄名称
      hero_data_plus: {}, //plus任务对应数据（packet_id）
      hero_plus_status: '', //plus按钮状态
      hero_arr_plus: [],
      //击杀
      kill_arr: [], //基本数据数组
      kill_over_step: 0, //更新over_step
      kill_baseData: {}, //该任务对应数据（packet_id和按钮状态）

      //助攻
      assist_arr: [], //基本数据数组
      assist_over_step: 0, //更新over_step
      assist_baseData: {}, //该任务对应数据（packet_id和按钮状态）

      //连胜
      win_arr: [], //基本数据数组
      win_over_step: 0, //更新1:over_step
      win_baseData: {}, //该任务1对应数据（packet_id和按钮状态）
      win2_over_step: 0, //更新2:over_step
      win3_over_step: 0, //plus更新3:over_step
      win_data_plus: {}, //plus任务对应数据（packet_id）
      win_plus_status: '', //plus按钮状态
      win_arr_plus: [],

      dan10_data: {}, //10连基本数据数组
      dan10_status: '', //10连按钮状态
      dan10p_data: {}, //10单人挑战plus基本数据数组
      dan10p_status: '', //10单人挑战plus按钮状态
      lian3_data: {}, //3连基本数据数组
      lian3_status: '', //3连按钮状态
      lian3p_data: {}, //3连plus基本数据数组
      lian3p_status: '', //3连plus按钮状态
      ying10p_data: {}, //10胜奖励基本数据数组
      ying10p_status: '', //10胜励按钮状态

      add_exploit_baseData: [], //赛季经验所有数据数组
      Changed_list: [], //兑换过的列表

      present_exploit_baseData: [], //当前福利点所有数据
      choo_id: 0,
      choo_item: null,
      packet: null,

      k: '',
      lp: [], //未用到
      zx_heroBaseData: [],
      td: today,
      l_s: 0,

      plus_flag: 0, //是否为plus
      add_exploit_count: 0, //赛季经验的数量
      present_exploit_count: 0, //当前福利点数量
      p_s: null, //打开大弹框的类型  1.prev 预览 2.yc 补领 3.bh 开通plus

      score: {}, //当前段位基本信息
      danGrading_data: [], //所有段位基本礼包
      my_danGrading_data: null, //我的段位基本数据
      my_danGrading_balance: 0,
      have_pcg: false, //是否拥有上周段位奖励的礼包
      m_s_p: [], //段位礼包列表
      my_win_count: 0, //我的当前胜场

      m_l: 0, //未用到
      p_w: 0, //未用到
      btn_clock: 0, //防抖
      b_t: 0, //未用到

      // sign_btn_status: 0, //是否签到，更新签到按钮状态
      turn_remain: 1, //周转盘剩余次数

      shengxia: 0, //plus的剩余天数

      total_exploit: 0, //总赛季经验，也是补领数量
      c_f: 0, //最终补领数量
      slider: {
        width: 100, //补领滑块的初始长度
      },
      videoUrl: '', //预览地址
      videoName: '', //预览名称

      progressH: 0, //经验进度条高度
      tlWidth: 0,

      btype: 0,
      exchange_list: [],
      is_dw: false,
      duanWei: '', //累计奖励用来判断段位，直接领取
      sxSp2heroStatus: true,
      ex_id: 20163, //兑换道具id
      // ex_id: 20081, //兑换道具id（测试）
      my_box_amount: 0, //我的超值酒豆宝箱个数
      is_first: true, //是否首次开启酒豆宝箱
      is_shaking: false, //是否开启摇晃动画
      timer_openbox: null,
      timer:null,
      prize_info: null,

      width: '6rem',
      height: '6rem',
      blocks: [],
      prizes: [],
      buttons: [],
      login_count: 0, //本周登录天数
      moveT: 0,
      last_count: 0,
      weekLoginList: {
        cn:''
      }, // 周登陆天数
      throttledHandler: null, //节流函数
      login_status:1, // 登陆礼包发放状态 1发放 0未发放
      duanweiList:[
        {
          name:'大师',
          count:10
        },
        {
          name:'战神',
          count:20
        },
        {
          name:'传奇',
          count:30
        },
        {
          name:'超凡至尊Ⅰ',
          count:40
        },
        {
          name:'超凡至尊Ⅱ',
          count:60
        },
        {
          name:'超凡至尊Ⅲ',
          count:80
        },
        {
          name:'超凡至尊Ⅳ',
          count:110
        },
        {
          name:'超凡至尊Ⅴ',
          count:140
        },
        {
          name:'超凡至尊Ⅵ',
          count:180
        },
        {
          name:'超凡至尊Ⅶ',
          count:240
        },
        {
          name:'超凡至尊Ⅷ',
          count:320
        },
        {
          name:'超凡至尊Ⅸ',
          count:420
        },
        {
          name:'超凡至尊Ⅹ',
          count:520
        }
      ],
    }
  },
  computed:{
		cpName(){
			let name = '';
			if(this.score.level >=3 && this.score.level < 16){
				name =  this.duanweiList[this.score.level - 3].name
			}else if (this.score.level >= 16){
				name =  this.duanweiList[this.duanweiList.length - 1].name
			}
			return  name;
		},
		cpCount(){
			let count = 0;
			if(this.score.level >= 3 && this.score.level < 16){
				count =  this.duanweiList[this.score.level - 3].count
			}else if (this.score.level >= 16){
				count =  this.duanweiList[this.duanweiList.length - 1].count
			}
			return  count;
		},
		cpkillScore(){
			return this.kill_baseData ? this.kill_baseData.packet_name ? this.kill_baseData.packet_name.slice(0, -4) : 50 : 50;
		}
	},
  mounted() {
    document.addEventListener('scroll', this.downFunc)
    this.throttledHandler = this.throttle(function (i, d ,t) {
        this.get_present_award(i,d,t)
    }, 1000, true)
  },
  beforeDestroy() {
    document.removeEventListener('scroll', this.downFunc)
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.$router.push('/s35')
      return
      if (vm.$common.checkToken(vm.token)) {
        vm.$http.set_anchor(14, vm.token)
      }
    })
  },
  created() {
    mouse = document.onmousewheel;
    this.requireToken()
  },
  methods: {
    		// 节流函数
		throttle(fn, wait, immediate = true) {
			let timer = null;
			let lastArgs = null;

			return function (...args) {
				const context = this;
				lastArgs = args; // 始终保存最新参数

				if (!timer) {
					if (immediate) {
						// 立即执行模式
						fn.apply(context, args);
						timer = setTimeout(() => {
							timer = null;
							if (!immediate) {
								// 非立即模式需要执行最后一次
								fn.apply(context, lastArgs);
							}
						}, wait);
					} else {
						// 延迟执行模式
						timer = setTimeout(() => {
							fn.apply(context, args);
							timer = null;
						}, wait);
					}
				}else{
					let index = lastArgs[1]
					let type = lastArgs[2]
          let element = ''
					if(type == 1){
						element = `.part.part3 .p3c .p3Item${index} .p3Itemtop .p3btn`
					}else{
						element = `.part.part3 .p3c .p3Item${index} .p3Itembot .p3btn`
					}
					let text = '兑换过快，请稍等！'
					this.mate_show(element, text, -40 , 10);
				}
			};
		},
    // 初始化转盘数据
    init_plate() {
      this.blocks = [
        {
          // padding: '0.46rem',
          imgs: [
            {
              src: require('@/assets/img/s34/pop/plate.png'),
              width: this.width,
              height: this.height,
              rotate: true,
            },
          ],
        },
      ]

      const prizes = [
        {
          id: 1,
          item_count: 666,
          icon: require('@/assets/img/s34/pop/666.png'),
          title: '666酒豆（有效期7天）',
        },
        {
          id: 2,
          item_count: 50,
          icon: require('@/assets/img/s34/pop/50.png'),
          title: '赛季经验*50',
        },
        {
          id: 3,
          item_count: 100,
          icon: require('@/assets/img/s34/pop/100.png'),
          title: '赛季经验*100',
        },
        {
          id: 4,
          item_count: 200,
          icon: require('@/assets/img/s34/pop/200.png'),
          title: '赛季经验*200',
        },
        {
          id: 5,
          item_count: 1666,
          icon: require('@/assets/img/s34/pop/1666.png'),
          title: '1666酒豆（有效期7天）',
        },
        {
          id: 6,
          item_count: 400,
          icon: require('@/assets/img/s34/pop/400.png'),
          title: '赛季经验*400',
        },
        {
          id: 7,
          item_count: 800,
          icon: require('@/assets/img/s34/pop/800.png'),
          title: '赛季经验*800',
        },
        {
          id: 8,
          item_count: 1600,
          icon: require('@/assets/img/s34/pop/1600.png'),
          title: '赛季经验*1600',
        },
      ]
      this.prizes = prizes.map((item) => ({
        // fonts: [
        //     {
        //         text: item.title,
        //         top: '55%',
        //         fontColor: '#ffffff ',
        //         fontSize: '0.18rem',
        //         fontWeight: 600,
        //         wordWrap: false,
        //         lineHeight: '0.18rem',
        //     },
        // ],
        info: {
          id: item.id,
          item_count: item.item_count,
          name: item.title,
        },
        imgs: [{ src: item.icon, top: '0.64rem', width: '1.08rem', height: '1.32rem' }],
      }))

      this.buttons = [
        {
          radius: '0%',
          imgs: [
            {
              src: require('@/assets/img/s34/pop/point.png'),
              top: '-3rem',
              width: '6rem',
              height: '6rem',
            },
          ],
        },
      ]
    },
    open_turn_pop() {
      if (!this.turn_remain) {
        return false
      }
      this.p_s = 'turn'
    },
    // 开启轮盘抽奖
    startCallback() {
      let element = '.inner.turn .btn'
      if (this.btn_clock) {
        return false
      }
      if (!this.turn_remain) {
        return false
      }
      this.btn_clock = 1
      console.log('#@@@@@')
      // 调用抽奖组件的play方法开始游戏
      $.ajax({
        url: w_u + '/WeekRand?token=' + this.token,
        success: (res) => {
          if (res.code == 0) {
            this.$refs.myLucky.play()
            let index = parseInt(res.rand) - 1
            // 调用stop停止旋转并传递中奖索引
            this.$refs.myLucky.stop(index)
            this.turn_remain --;
          } else {
            this.btn_clock = 0
            this.mate_show(element, res.msg ? res.msg : '操作失败，请联系管理员', -50, 10)
          }
        },
      })
    },
    // 抽奖结束会触发end回调
    endCallback(prize) {
      // console.log(JSON.stringify(prize));
      this.mate_show('.inner.turn .btn', `恭喜获得：${prize.info.name}`, -50, 10)
      this.btn_clock = 0
      this.init_my_gx_item()
    },
    // 开启酒豆宝箱
    open_jd_box() {
      let element = '.inner.l_reward .btn'
      let text = ''
      if (this.my_box_amount <= 0) {
        return false
      }
      if (this.btn_clock) {
        return false
      }
      if (this.is_shaking) {
        return false
      }
      this.prize_info = null
      this.is_shaking = true
      this.timer_openbox = setTimeout(() => {
        this.btn_clock = 1
        use_packet(this.token, this.present_exploit_baseData[0].packet_id).then((res) => {
          if (res.error == null && res.data.code == 0) {
            let info = res.data ? res.data.info : '开启失败'
            info = info.match(/= (\S*)/)[1]
            this.prize_info = { id: 0, name: info ? `${info}酒豆（有效期7天）` : '开启失败' }
            this.is_first = false
            text = '领取成功'
            this.query_plusPacket()
            setTimeout(() => {
              this.is_shaking = false
              this.btn_clock = 0
            }, 500)
          } else {
            this.btn_clock = 0
            text = res.data ? res.data.info : '开启失败'
            this.mate_show(element, text, -40, 10)
          }
        })
      }, 1000)
    },

    downFunc() {
      let distanceToBottom = window.innerHeight + window.pageYOffset;
      let documentHeight = document.documentElement.scrollHeight;
      let threshold = 20; // 你可以根据需要调整这个阈值

      if (distanceToBottom >= documentHeight - threshold) {
        // 显示箭头或执行其他操作
        this.isActive = true
      } else {
        // 隐藏箭头或执行其他操作
        this.isActive = false
      }
    },
    requireToken() {
      var Ucookie = this.token
      if (Ucookie != null) {
        var now = new Date().getTime()
        if (now >= Ucookie.split('-')[3] * 1000) {
          //token过期
          this.get_auth()
        } else {
          this.init()
        }
      } else {
        this.get_auth()
      }
    },
    get_auth() {
      window.location.replace(base_url + '/GetWxOpenid?fromPage=s34')
    },
    init() {
      this.token = this.$storage.getToken()
      _09game = new $09game(this.token, this.app_id)
      this.user_id = this.token.split('-')[0]
      var nowDate = new Date()
      var y = nowDate.getFullYear()
      var m = nowDate.getMonth() + 1
      var d = nowDate.getDate()
      var now = y + '-' + m + '-' + d
      var days = compareTime('2020-10-5', now)
      this.is_dw = days
      this.my_box_amount = 0
      this.query_win()
      this.query_cfg_packet()
      this.query_user_baseInfo()
      this.query_taskRegroup()
      // this.query_sign_status()
      this.query_allexploit_count()
      this.init_herolist()
      // this.query_weekHero()
      this.init_plate()
    },

    jumpSp2() {
      window.open('https://go.09game.com/?id=1324', '_blank')
    },
    // 查询活动礼包
    query_cfg_packet() {
      _09game.q_d(
        'q_cfg_packet',
        {
          app_id: this.app_id,
        },
        (res) => {
          if (res.code == 0) {
            if (res.records) {
              var reward_list = []
              var exchange_list = []
              // var weekLoginList = {};
              for (var i in res.records) {
                var item = res.records[i]
                item.count = 0
                item.cn = ''
                item.p = null
                if (item.packet_id >= 920225 && item.packet_id <= 920241) {
                  //累计兑换礼包 需要修改
                  reward_list.push(item)
                }
                if (item.packet_id >= 920242 && item.packet_id <= 920247) {
                  //兑换礼包 需要修改
                  exchange_list.push(item)
                }
                //每周登陆礼包
                // if (item.packet_id === 920201) {
                //   weekLoginList = item;
                // }
              }
              for (var j in reward_list) {
                var js = reward_list[j]
                js.s = []
                for (var o = 1; o <= 6; o++) {
                  if (js['gift' + o + '_setting']) {
                    js.s.push(JSON.parse(js['gift' + o + '_setting']))
                  }
                }
                if (js.use_flag & 2) {
                  for (var t in js.s) {
                    var ts = js.s[t]
                    ts.h_amount = 0
                    ts.have = false
                  }
                }

                js.name = js.packet_name
                js.count = js.packet_id == 920241 ? 18000 : js.name.split(',')[1]
                js.packet_name = js.name.split(',')[0]
              }
              for (var k in exchange_list) {
                var ks = exchange_list[k]
                ks.s = []
                for (var o = 1; o <= 6; o++) {
                  if (ks['gift' + o + '_setting']) {
                    ks.s.push(JSON.parse(ks['gift' + o + '_setting']))
                  }
                }
              }
              // if (weekLoginList) {
              //   var hs = weekLoginList;
              //   hs.s = []
              //   for (var o = 1; o <= 6; o++) {
              //     if (hs['gift' + o + '_setting']) {
              //       hs.s.push(JSON.parse(hs['gift' + o + '_setting']));
              //     }
              //   }
              // }
              this.add_exploit_baseData = reward_list
              this.exchange_list = exchange_list
              // this.weekLoginList = weekLoginList;
            }
          }
        }
      )
    },
    // 查询用户单个游戏(全部，自由）模式的当前积分信息(根据score取相对应段位数据)
    query_score_data() {
      $.ajax({
        url: 'https://score.09game.com/Ordinary/SeasonSummaryV1?UserID=' + this.token.split('-')[0] + '&GameTypeID=21',
        success: (r) => {
          $.ajax({
            url: 'https://score.09game.com/Ordinary/SeasonSummaryV1?UserID=' + this.token.split('-')[0] + '&GameTypeID=1',
            success: (z) => {
              $.ajax({
                url:
                  'https://score.09game.com/Ordinary/SeasonSummaryV1?UserID=' +
                  this.token.split('-')[0] +
                  '&GameTypeID=2',
                success: (c) => {
                  var score = Math.max(
                    r.data.season[0] ? r.data.season[0].score : 100,
                    Math.max(
                      z.data.season[0] ? z.data.season[0].single_score : 100,
                      c.data.season[0] ? c.data.season[0].score : 100
                    )
                  )
                  this.score = dotaSeason[0](score)
                  this.query_danGrading_baseData()
                },
              })
            },
          })
        },
      })
    },
    // 查询活动任务(取对应任务重组数据,这四个接口q_cfg_task,q_my_task,q_cfg_packet,q_my_packet，重组后对应数据)
    query_taskRegroup() {
      this.d_t = []
      this.kill_arr = []
      this.assist_arr = []
      this.win_arr = []
      this.kill_over_step = 0
      this.assist_over_step = 0
      this.win_over_step = 0
      this.win2_over_step = 0
      this.win3_over_step = 0
      this.hero_over_step = 0

			_09game.q_t((r) => {
				for (var i in r) {
					var item = r[i];
					//段位任务  需要修改
					// if (item.task_id >= 500766 && item.task_id <= 500778) { 
					// 	item.task_name = item.task_name.split('段位')[0];
					// 	this.d_t.push(item);
					// }
					//每周击杀任务  需要修改
					if (item.task_id >= 501059 && item.task_id <= 501063) {
						if (item.over_step > this.kill_over_step && item.c.e_t >= w_b) {
							this.kill_over_step = item.over_step;
							this.kill_baseData = item;
						}
						this.kill_arr.push(item);
					}

					//  else if (item.task_id >= 500759 && item.task_id <= 500763) {
					// 	//助攻任务  需要修改
					// 	if (item.over_step > this.assist_over_step && item.c.e_t >= w_b) {
					// 		this.assist_over_step = item.over_step;
					// 		this.assist_baseData = item;
					// 	}
					// 	this.assist_arr.push(item);
					// } 
					else if (item.task_id >= 501064 && item.task_id <= 501065) {
						//每周挑战任务  需要修改  ->周挑战
						if (item.over_step > this.win_over_step && item.c.e_t >= w_b) {
							// 酒币开启10次单人挑战
							if (item.task_id == 501064) { //需要修改
								this.win_over_step = item.over_step;
								// this.win_baseData = item;
							}
						}
						if (item.over_step > this.win2_over_step && item.c.e_t >= w_b) {
							if (item.task_id == 501065) {//需要修改
								// 酒币开启3次连胜挑战
								this.win2_over_step = item.over_step;
								// this.win_baseData = item;
							}
						}
						this.win_arr.push(item);
					}else if (item.task_id == 501066) {
						// 每周赛季胜利10场【PLUS专属】
						this.win3_over_step = item.over_step;
					}
					// else if (item.task_id == 500897) {//需要修改
					// 	// 周任务，随机英雄
					// 	if (item.over_step > this.hero_over_step && item.c.e_t >= w_b) {
					// 		this.hero_over_step = item.over_step;
					// 		this.hero_baseData = item;
					// 	}
					// 	this.hero_arr.push(item)
					// }
				}

				this.update_task_btn(); //更新按钮状态cn
				this.query_my_item_count(); //查询我的道具数量
			})
    },
    // 查询我的赛季经验数量
    init_my_gx_item() {
      _09game.q_d(
        'q_my_item',
        {
          token: this.token,
          item_id: 20162,
        },
        (r) => {
          if (r.code == 0) {
            this.add_exploit_count = r.records[0].amount //我的赛季经验数量
          } else {
            this.add_exploit_count = 0
          }
        }
      )
      _09game.q_d(
        'q_my_item',
        {
          token: this.token,
          item_id: this.ex_id,
        },
        (r) => {
          if (r.code == 0) {
            this.present_exploit_count = r.records[0].amount //我的当前福利点数量
          } else {
            this.present_exploit_count = 0
          }
        }
      )
    },
    //查询我的道具数量
    query_my_item_count() {
      _09game.q_d(
        'q_my_item',
        {
          token: this.token,
          item_id: 20162,
        },
        (r) => {
          if (r.code == 0) {
            this.add_exploit_count = r.records[0].amount //我的赛季经验数量
          } else {
            this.add_exploit_count = 0
          }
          this.query_change_log()
        }
      )
      _09game.q_d(
        'q_my_item',
        {
          token: this.token,
          item_id: this.ex_id,
        },
        (r) => {
          if (r.code == 0) {
            this.present_exploit_count = r.records[0].amount //我的当前福利点数量
          } else {
            this.present_exploit_count = 0
          }
          _09game.q_d(
            'q_cfg_item',
            {
              ITEM_ID: this.ex_id,
            },
            (r) => {
              if (r.code == 0) {
                var e_l = JSON.parse(r.records[0].setting).ex
                for (var u in e_l) {
                  var us = e_l[u]
                  for (var t in this.exchange_list) {
                    //获取兑换列表中对应的福利点数量
                    var exchange = this.exchange_list[t]
                    if (exchange.packet_id == us.packet) {
                      exchange.count = us.count
                    }
                  }
                }
                this.present_exploit_baseData = this.exchange_list
              } else {
                console.log(r.info)
              }
              _09game.q_t_p((r) => {
                if (r.code == 0) {
                  for (var i in r.records) {
                    var item = r.records[i]
                    for (var j in this.present_exploit_baseData) {
                      var _item = this.present_exploit_baseData[j]
                      if (item.packet_id == _item.packet) {
                        _item = $.extend(_item, item)
                      }
                    }
                  }
                }
              })
            }
          )
        }
      )
    },
    // 获取用户基础信息（是否为plus，以及plus的剩余天数）
    query_user_baseInfo() {
      $.ajax({
        url: 'https://users.09game.com/home/GetUserPub?user_id=' + this.token.split('-')[0],
        async: false,
        success: (res) => {
          if (res.result == 0) {
            var u = res.temp[0]
            this.user_name = u.user_name
            this.$storage.setUserId(u.user_id)
            this.$storage.setUserName(u.user_name)
            if (u.flag & 1024) {
              this.plus_flag = 1 //是PLUS会员
            } else {
              this.plus_flag = 0
            }
            this.query_plusPacket()
            this.query_turn_status()
            //获取plus会员剩余天数
            _09game.q_d(
              'q_my_item',
              {
                token: this.token,
                item_id: 20052,
              },
              (r) => {
                if (r.code == 0 && r.records.length > 0 && r.records[0].amount > 0) {
                  this.shengxia = r.records[0].amount
                } else {
                  this.shengxia = 0
                }
              }
            )
          } else {
            console.log('获取用户信息错误，错误码：' + res.result)
          }
        },
      })
      this.$http.getAllUser(this.token).then((res) => {
        if (res.result == 0 && res.msg && res.msg.length > 0) {
          this.account_list = res.msg
          this.$storage.setAccountList(JSON.stringify(res.msg))
        } else {
          this.account_list = []
        }
      })
    },
    // 兑换日志
    query_change_log() {
      this.Changed_list = []
      $.ajax({
        url: w_u + '/CumulativeMeritorious?token=' + this.token,
        success: (res) => {
          if (res.code == 0) {
            this.Changed_list = res.msg
          } else {
            this.Changed_list = []
          }
          this.last_count = res.count;
          this.undate_add_btn()
        },
      })
    },
    //是否转过转盘
    query_turn_status() {
      $.ajax({
        url: w_u + '/GetWeekRand?token=' + this.token,
        success: (res) => {
          let turn_times = 0; //已经转过的次数
          if (res.code == 0 && res.msg && res.msg.length>0) {
            turn_times = res.msg.length;
          } else {
            turn_times = 0;
          }
          this.turn_remain = (this.plus_flag?2:1) - turn_times;
          this.turn_remain = this.turn_remain <=0 ? 0 : this.turn_remain
        },
      })
    },
    //是否签到
    // query_sign_status() {
    //   $.ajax({
    //     url: w_u + '/GetSignIn?token=' + this.token,
    //     success: (res) => {
    //       if (res.code == 0) {
    //         this.sign_btn_status = 1
    //       } else {
    //         this.sign_btn_status = 0
    //       }
    //     },
    //   })
    // },
    //签到
    // to_sign() {
    //   let element = '.task-list .task-item1 .btn_box'
    //   let text = ''
    //   if (!this.sign_btn_status) {
    //     return
    //   }
    //   if (this.btn_clock) {
    //     return
    //   }
    //   this.btn_clock = 1

    //   $.ajax({
    //     url: w_u + '/SignIn?token=' + this.token,
    //     success: (res) => {
    //       text = ''
    //       if (res.code == 0) {
    //         text = res.msg
    //         var count = Number(res.msg.split('：')[1])
    //         this.present_exploit_count = this.present_exploit_count + count
    //         this.add_exploit_count = this.add_exploit_count + count
    //         this.undate_add_btn()
    //         this.sign_btn_status = 0
    //       } else {
    //         text = res.msg ? res.msg : res.error
    //       }
    //       this.btn_clock = 0
    //       this.mate_show(element, text, -40, 10)
    //     },
    //   })
    // },
		// 领取礼包
		get_packet(item) {
			let element = `.taskContent .task3 .taskbtn`;
			let text = '';
			if(item.cn !='get'){
				return
			}

			if (this.btn_clock) {
				return false;
			}
      this.btn_clock = 1;
			$.ajax({
				url: w_u + '/SendWeekPacket?token=' + this.token,
				success: (res) => {
					if (res.code == 0) {
						this.query_my_item_count()
						this.query_win()
						text = '领取成功';
						this.mate_show(element, text,-40, 10);
						this.btn_clock = 0;
					} else {
						text = res.msg ? res.msg : '领取失败!';
						this.btn_clock = 0;
						this.mate_show(element, text,-40, 10);
					}
				}
			})
		},
    //查询我的胜场
    query_win() {
      $.ajax({
        url: w_u + '/GetWin?token=' + this.token,
        async: false,
        success: (res) => {
          if (res.code == 0 && res.msg) {
            this.my_win_count = res.msg.total_times
            this.duanWei = res.msg.score
            this.login_count = res.msg.login_count
            this.score = dotaSeason[0](res.msg.score)
            this.login_status = res.msg.add_count
            if (res.msg.login_count >= 5 && res.msg.add_count == 0 ) {
							this.weekLoginList.cn = 'get'
						}else if(res.msg.login_count >= 5 && res.msg.add_count > 0 ){
							this.weekLoginList.cn = 'over'
						}else{
							this.weekLoginList.cn = ''
						}
            this.undate_add_btn()
            this.query_danGrading_baseData()
          } else {
            this.duanWei = ''
            this.my_win_count = 0
            this.login_count = 0
          }
        },
      })
    },
    //补领数量（全部赛季经验）
    query_allexploit_count() {
      $.ajax({
        url: w_u + '/GetMeritorious?token=' + this.token,
        success: (res) => {
          if (res.code == 0) {
            this.total_exploit = res.msg
          } else {
            this.total_exploit = 0
            // console.log(res.error)
          }
        },
      })
    },
    // 更新按钮点击状态
    update_task_btn() {
      var h_obj = null
      var k_obj = null
      var a_obj = null
      var l_obj = null
      // 随机英雄
      // for (var i in this.hero_arr) {
      //     var item = this.hero_arr[i]
      //     item.cn = ''
      //     if (item.c && item.c.e_t >= w_b) {
      //         if (item.p && item.p.balance > 0 && item.p.expire_days > 0) {
      //             item.cn = 'get'
      //             h_obj = item
      //             break
      //         } else {
      //             if (item.c.over_step >= item.c.total_step) {
      //                 item.cn = 'over'
      //             }
      //         }
      //         if (item.over_step < item.c.total_step) {
      //             h_obj = item
      //             break
      //         }
      //         if (i == this.hero_arr.length - 1) {
      //             h_obj = item
      //         }
      //         // k_obj = item;
      //     }
      // }
      // 击杀
      for (var i in this.kill_arr) {
        var item = this.kill_arr[i];
        item.cn = ""
        if (item.c && item.c.e_t >= w_b || item.p) {
          if (item.p && item.p.balance > 0 && item.p.expire_days > 0) {
            item.cn = 'get';
            k_obj = item;
            break;
          } else {
            if (item.c && item.c.over_step >= item.c.total_step) {
              item.cn = 'over'
            }
          }
          if (item.c && item.over_step < item.c.total_step) {
            k_obj = item;
            break;
          }
          if (i == (this.kill_arr.length - 1)) {
            k_obj = item;
          }
          // k_obj = item;
        }
      }
      console.log('k_obj', k_obj ,this.kill_arr);
      
      // 助攻
      // for (var i in this.assist_arr) {
      //     var item = this.assist_arr[i]
      //     item.cn = ''
      //     if (item.c && item.c.e_t >= w_b) {
      //         if (item.p && item.p.balance > 0 && item.p.expire_days > 0) {
      //             item.cn = 'get'
      //             a_obj = item
      //             break
      //         } else {
      //             if (item.c.over_step >= item.c.total_step) {
      //                 item.cn = 'over'
      //             }
      //         }
      //         if (item.over_step < item.c.total_step) {
      //             a_obj = item
      //             break
      //         }
      //         if (i == this.assist_arr.length - 1) {
      //             a_obj = item
      //         }

      //         // a_obj = item;
      //     }
      // }
      // 周挑战
      for (var i in this.win_arr) {
        var item = this.win_arr[i];
        item.cn = "";
        if (item.c && item.c.e_t >= w_b || item.p) {
          if (item.p && item.p.balance > 0 && item.p.expire_days > 0) {
            item.cn = 'get';
            l_obj = item;
            break;
          } else {
            if (item.c && item.c.over_step >= item.c.total_step) {
              item.cn = 'over'
            }
          }
          if (item.c && item.over_step < item.c.total_step) {
            l_obj = item;
            // break;
          }
          if (i == (this.win_arr.length - 1)) {
            l_obj = item;
          }
          // l_obj = item;
        }
      }
      // this.hero_baseData = h_obj ? h_obj : this.hero_arr[0]
      this.kill_baseData = k_obj ? k_obj : this.kill_arr[0]
      // this.assist_baseData = a_obj ? a_obj : this.assist_arr[0]
      this.win_baseData = l_obj ? l_obj : this.win_arr[0]
    },
    // 查询段位奖励相关活动礼包 func_id 活动1
    query_danGrading_baseData() {
      this.m_s_p = []
      _09game.q_d(
        'q_cfg_packet',
        {
          func_id: 1,
          app_id: this.app_id,
        },
        (res) => {
          if (res.code == 0) {
            this.danGrading_data = res.records
            if (this.score.level >= 4) {
              this.my_danGrading_data = this.danGrading_data[this.score.level - 4] //我的当前段位奖励任务
            }
            _09game.q_d(
              'q_my_packet',
              {
                token: this.token,
                func_id: 1,
                app_id: this.app_id,
              },
              (res) => {
                if (res.code == 0) {
                  let count = 0
                  let sum_blc = 0
                  for (var i in res.records) {
                    if (res.records[i].balance > 0 && res.records[i].expire_days > 0) {
                      sum_blc += res.records[i].balance //我的段位礼包可领次数
                      this.m_s_p.push(res.records[i])
                    }
                    if (res.records[i].expire_days > 0) {
                      count++
                    }
                  }
                  this.have_pcg = count > 0 ? true : false //有无可领段位礼包
                  this.my_danGrading_balance = sum_blc
                } else {
                  this.have_pcg = false
                  this.my_danGrading_balance = 0
                }
              }
            )
          }
        }
      )
    },
    // 领取对应plus
		get_plus_task(item, d) {
			let  element = ` .part .taskContent .task${d} .taskbtn1`;
			let text = " ";
			if (d == 5 && this.lian3p_status != 'get') {
				return false
			}else if(d==4 && this.dan10p_status != 'get'){
				return false
			}else if (d==6 && this.ying10p_status != 'get'){
				return false
			}
			if (!this.plus_flag) {
				this.p_s = 'bh';
			} else {
				this.btn_clock = 1
				use_packet(this.token, item.packet_id).then(res => {
					if (res.error == null && res.data.code == 0) {
						text = '领取成功';
						this.query_my_item_count()
						this.query_plusPacket();
					} else if (res.data.code == 75) {
						text = '这是Plus专属礼包（如已开通Plus，重登平台生效）'
					} else {
						text = res.data ? res.data.info : '领取失败'
					}
					this.btn_clock = 0
					this.mate_show(element,text,-40,10);
				})
			}
		},
    // 所有活动的plus任务数据
    query_plusPacket() {
      this.hero_arr = []
      this.hero_arr_plus = []
      this.win_arr_plus = []
			q_my_packet(this.app_id, this.token).then(res => {
				if (res.error == null && res.data.code == 0) {
					let data = res.data.records
					for (var i in data) {
						var element = data[i];
						//需要修改 每周登录平台福利，Plus用户
						if (element.packet_id == 920202) {
							if (element.balance > 0 && element.expire_days > 0) {
								this.hero_data_plus = element
								this.hero_plus_status = 'get';
							}else if(element.balance == 0 && element.expire_days > 0 && this.loginCount >= 5){
								this.hero_plus_status = 'over';
							}else{
								this.hero_plus_status = '';
							}
							this.hero_arr_plus.push(element)
						}
						if(element.packet_id == 920208){
							if (element.balance > 0 && element.expire_days > 0) {
								this.dan10_data = element
								this.dan10_status = 'get'
							}else if(element.balance == 0 && element.expire_days > 0){
								this.dan10_status = 'over';
							}else{
								this.dan10_status = '';
							}
						}
						if(element.packet_id == 920210){
							if (element.balance > 0 && element.expire_days > 0) {
								this.dan10p_data = element
								this.dan10p_status = 'get'
							}else if(element.balance == 0 && element.expire_days > 0){
								this.dan10p_status = 'over';
							}else{
								this.dan10p_status = '';
							}
						}
						if(element.packet_id == 920209){
							if (element.balance > 0 && element.expire_days > 0) {
								this.lian3_data = element
								this.lian3_status = 'get'
							}else if(element.balance == 0 && element.expire_days > 0){
								this.lian3_status = 'over';
							}else{
								this.lian3_status = '';
							}
						}
						if(element.packet_id == 920211){
							if (element.balance > 0 && element.expire_days > 0) {
								this.lian3p_data = element
								this.lian3p_status = 'get'
							}else if(element.balance == 0 && element.expire_days > 0){
								this.lian3p_status = 'over';
							}else{
								this.lian3p_status = '';
							}
						}
						if(element.packet_id == 920202){
							if (element.balance > 0 && element.expire_days > 0) {
								this.ying10p_data = element
								this.ying10p_status = 'get'
							}else if(element.balance == 0 && element.expire_days > 0){
								this.ying10p_status = 'over';
							}else{
								this.ying10p_status = '';
							}
						}
					}

				} else {
					this.hero_plus_status = '';
					this.win_plus_status = '';
				}
				this.update_allPlus_btn()
			})
    },
    // 更新只有plus才可以领的任务按钮
    update_allPlus_btn() {
      let hero_Obj = null
      let win_Obj = null
      let hero_baseObj = null

      for (let i in this.hero_arr) {
        let item = this.hero_arr[i]
        if (item.balance > 0 && item.expire_days > 0) {
          this.hero_baseStatus = 'get'
          hero_baseObj = item
          break
        } else {
          if (item.balance == 0 && item.expire_days > 0 && this.login_count >= 5) {
            this.hero_baseStatus = 'over'
          }
          if (this.hero_baseData.cn == '') {
            this.hero_baseStatus = ''
          }
        }
      }

      for (let i in this.hero_arr_plus) {
        let item = this.hero_arr_plus[i]
        if (item.balance > 0 && item.expire_days > 0) {
          this.hero_plus_status = 'get'
          hero_Obj = item
          break
        } else {
          if (item.balance == 0 && item.expire_days > 0 && this.login_count >= 5) {
            this.hero_plus_status = 'over'
          }
          if (this.hero_baseData.cn == '') {
            this.hero_plus_status = ''
          }
        }
      }

      for (let i in this.win_arr_plus) {
        let item = this.win_arr_plus[i]
        if (item.balance > 0 && item.expire_days > 0) {
          this.win_plus_status = 'get'
          win_Obj = item
          break
        } else {
          if (item.balance == 0 && item.expire_days > 0) {
            this.win_plus_status = 'over'
          }
          if (this.win_baseData.cn == '') {
            this.win_plus_status = ''
          }
        }
      }
      this.hero_data_plus = hero_Obj ? hero_Obj : this.hero_arr_plus[0]
      this.win_data_plus = win_Obj ? win_Obj : this.win_arr_plus[0]
      this.hero_baseData = hero_baseObj ? hero_baseObj : this.hero_arr[0]
    },
    // 取每周英雄的名字
    query_weekHero() {
      $.ajax({
        url: `${w_u}/GetWeekHeros`,
        data: {
          user_id: this.user_id,
        },
        success: (res) => {
          if (res.code == 0) {
            // this.radom_hero = res.msg.hero_name
            this.duanWei = res.msg.score
            this.undate_add_btn()
          }
        },
      })
    },
    // 点击领取赛季经验任务
		get_task(i, t) {
			let element = `.part1 .taskContent .task.task${t} .taskbtn.taskbtn2`;
			let text = '';
			let _this = this;
			if(i.cn !='get' && t==2){
				return
			}
			if(t == 4 && this.dan10_status != 'get'){
				return
			}
			if(t == 5 && this.lian3_status != 'get'){
				return
			}
			if (this.btn_clock) {
				return
			}
			this.btn_clock = 1;
			_09game.g_t(i.packet_id, (r) => {
				 text = '';
				if (r.code == 0) {
					text = "领取成功！";
					if(t!= 2){
						_this.query_plusPacket();
						_this.query_change_log()
						_this.query_taskRegroup()
					}else{
						i.p.balance = i.p.balance - 1;
						_this.query_taskRegroup()
					}
				} else {
					text = r.info;
				}
				_this.btn_clock = 0;
				_this.mate_show(element, text,-40, 10);
			})
    },
    // 确定补领
    confirm_retroactive() {
      //补领
      let element = '.btn-sign-1'
      let text = ''
      if (this.c_f <= 0) {
        return
      }
      if (this.btn_clock) {
        return
      }
      this.btn_clock = 1
      $.ajax({
        url: w_u + '/buqian?token=' + this.token + '&gongxun=' + this.c_f,
        success: (res) => {
          text = ''
          if (res.code == 0) {
            text = '补领成功！'
            this.btn_clock = 0
            this.show_pay_result(4, text, 2)
          } else if (res.code == 1 && res.jiubi > 0) {
            let money = Math.ceil(this.c_f / 2)
            this.pay_jiubi = money
            this.btn_clock = 0
            this.btype = 2
            this.buy()
          } else {
            text = res.error
            this.btn_clock = 0
            this.mate_show(element, text, -40, 10)
          }
        },
      })
    },
    show_pay_result(code, text, type) {
      let element = ''
      if (type == 1) {
        // 开通会员
        element = '.popbtn'
        if (code == 4) {
          this.u_h_i()
          this.query_user_baseInfo()
        } else {
          this.mate_show(element, text, -40, 10)
        }
      } else {
        //补领
        element = '.popbtn'
        if (code == 4) {
          this.total_exploit = this.total_exploit - this.c_f
          this.add_exploit_count = this.add_exploit_count + this.c_f
          this.present_exploit_count = this.present_exploit_count + this.c_f
          this.close_pop()
          this.undate_add_btn()
          this.query_user_baseInfo()
          // this.s_p_w();
          this.btn_clock = 0
          this.mate_show(element, text, -40, 10)
        } else {
          this.mate_show(element, text, -40, 10)
        }
      }
      this.btn_clock = 0;
    },

    // 是否为累计奖励plus可领
    is_plus_task(id) {
      if (id == 920235 || id == 920237 || id == 920239) {
        return true
      }
      return false
    },
    //累计兑换
    get_add_award(i, d) {
      //累计兑换
      let element =`.part.part2 .jfContent .jfItem${d} .p2btn`;
      // this.mate_show(element, '恭喜获得【超凡】神灵武士：斯巴达勇士', -40, 20)
      let text = ' '
      if (i.cn != 'get') {
        return false
      }
      if (this.is_plus_task(i.packet_id) && !this.plus_flag) {
        this.p_s = 'bh'
        return false
      }
      if (this.btn_clock) {
        return false
      }

      this.btn_clock = 1
      $.ajax({
        url: w_u + '/ReceiveProp?token=' + this.token + '&item_id=' + i.packet_id,
        success: (res) => {
          text = ''
          if (res.code == 0) {
            text = `领取成功：${res.msg}!`
            this.Changed_list.push({
              item_id: i.packet_id,
            })
            if(i.packet_id === 920241){
              this.last_count --;
              if(this.last_count <= 0){
                i.cn = ''
              }
            } else {
              i.cn = 'over'
            }
            this.init_my_gx_item();
            this.$set(this.add_exploit_baseData, d, i)
            this.btn_clock = 0
            this.mate_show(element, text, -40, 20)
          } else {
            text = res.msg ? res.msg : '领取失败！'
            this.mate_show(element, text, -40, 20)
            this.btn_clock = 0
          }
        },
      })
    },
    // 当前福利点兑换
		get_present_award(i, d ,type) {
			let element = ``
			if(type == 1){
				element = `.part.part3 .p3c .p3Item${d} .p3Itemtop .p3btn`
			}else{
				element = `.part.part3 .p3c .p3Item${d} .p3Itembot .p3btn`
			}
			let text =''
			if (i.count > this.present_exploit_count) {
				return
			}
			if (i.have) {
				return
			}
			if (this.btn_clock) {
				return
			}
			this.btn_clock = 1;
			_09game.q_d('use_item', {
				token: this.token,     
				dest_id: this.ex_id,
				amount: i.count
			}, (res) => {
				 text = '';
				if (res.code == 0) {
					this.present_exploit_count = this.present_exploit_count - i.count;
						text = '兑换成功！';
						this.mate_show(element, text, -40, 10);
						if(d == 0){
                this.query_plusPacket();
            }
						// if (i.packet_id == 909344) { //兑换列表永久皮肤 需要修改
						// 	i.have = true;
						// 	i.h_amount = 2000;
						// }
						// if (i.packet_id == 909345) { //兑换列表永久皮肤 需要修改
						// 	_09game.q_d('q_my_item', {
						// 		"item_id": 10180,
						// 		token: token
						// 	},  (d)=> {
						// 		if (d.code == 0) {
						// 			i.h_amount = d.records[0].amount;
						// 			if (d.records[0].amount >= 2000) {
						// 				i.have = true;
						// 			} else {
						// 				i.have = false;
						// 			}
						// 		}
						// 	})
						// }
				} else {
					text = res.info;
					this.mate_show(element, text,-40,11);
				}
				this.btn_clock = 0;
			})
		},
    selectSp2Hero() {
      if (this.present_exploit_count < 3199) {
        return false
      }
      this.update_herolist()
    },
    init_herolist() {
      $.ajax({
        url: w_u + '/GetSp2?user_id=' + this.user_id,
        success: (res) => {
          if (res.code == 0) {
            // console.log(res);
            let arr = res.msg
            let statusSp2 = ''
            for (let t in arr) {
              let val = arr[t]
              statusSp2 = formatYearMonth(val.month_number.toString())
              val.h_amount = 0
              val.have = false
              this.show_hero_status(val)
            }
            let today = query_time()
            // console.log('服务器',today);
            this.sxSp2heroStatus = isCurrentMonth(today, statusSp2)
            this.zx_heroBaseData = arr
            // this.p_s = 'c_reward'
          } else {
            console.log(res.msg)
            this.zx_heroBaseData = []
          }
        },
      })
    },
    update_herolist() {
      $.ajax({
        url: w_u + '/GetSp2?user_id=' + this.user_id,
        success: (res) => {
          if (res.code == 0) {
            // console.log(res);
            let arr = res.msg
            let statusSp2 = ''
            for (let t in arr) {
              let val = arr[t]
              statusSp2 = formatYearMonth(val.month_number.toString())
              val.h_amount = 0
              val.have = false
              this.show_hero_status(val)
            }
            let today = query_time()
            // console.log('服务器',today);
            this.sxSp2heroStatus = isCurrentMonth(today, statusSp2)
            this.zx_heroBaseData = arr
            this.p_s = 'c_reward'
          } else {
            console.log(res.msg)
            this.zx_heroBaseData = []
          }
        },
      })
    },
		sx_sp2Hero(){
			if(this.sxSp2heroStatus){
				// console.log('是当月的数据，不用刷了');
				return false
			}
			let text='';
			let element ='.pop .inner.c_reward .btnSx';
			$.ajax({
				url: w_u + '/SetSp2?token=' + this.token,
				success: (res) => {
					if (res.code == 0) {
						text = res.msg?res.msg:'刷新成功！'
						this.update_herolist();
						this.mate_show(element, text, -40 , 10 );
					} else {
						text = res.msg?res.msg:'刷新失败！'
						this.mate_show(element, text, -40 , 10 );
					}
				}
			})
		},
    // 展示自选英雄具体状态
    show_hero_status(i) {
      i.h_amount = 0
      _09game.q_d(
        'q_my_item',
        {
          item_id: i.item_id,
          token: this.token,
        },
        (r) => {
          if (r.code == 0) {
            i.h_amount = r.records[0].amount
            if (r.records[0].amount >= 2000) {
              i.have = true
            }
          } else {
            i.have = false
          }
        }
      )
    },
    show_zxBtn_status(i) {
      for (let each of i.s) {
        _09game.q_d(
          'q_my_item',
          {
            item_id: each.id,
            token: this.token,
          },
          (r) => {
            if (r.code == 0) {
              each.h_amount = r.records[0].amount
              if (each.h_amount >= 2000) {
                each.have = true
              } else {
                each.have = false
              }
            } else {
              each.h_amount = 0
              each.have = false
            }
          }
        )
      }

      i.have = i.s.every((res) => {
        return res.h_amount >= 2000
      })
    },
    chooId(i, d) {
      // if (d != 0 && !this.zx_heroBaseData[d - 1].have && i.id == 0) {
      // 	return false;
      // }
      if (i.have) {
        return false
      }
      // console.log(i);
      this.choo_id = i.item_id
      this.choo_item = i
    },
		// 确定自选的英雄
		confirm_zxHero(){
			let element = ''
			let text = ''
			if(this.choo_id === 0){
				element = '.pop .inner.c_reward .ghrbtn'
				this.mate_show(element , '请选择一个英雄！',-40,10);
				return
			}
			if(this.choo_item.have){
				element = '.pop .inner.c_reward .ghrbtn'
				this.mate_show(element , '您已拥有' + this.choo_item.item_name + '*永久，请更换选择！',-40,10);
				return
			}
			if(this.btn_clock){
				return
			}
			this.btn_clock = 1;
			$.ajax({
				url: w_u + '/SendSp2?token=' + this.token + '&item_id=' + this.choo_id,
				success: (res) => {
					if (res.code == 0) {
						element ='.part.part3 .p3c .p3lastdh .p3btn';
						text = res.msg?res.msg:'兑换成功！';
						this.btn_clock = 0;
						this.present_exploit_count = this.present_exploit_count - 3199;
						this.query_my_item_count()
						this.mate_show(element, text,-40,10);
						this.close_pop();
					} else {
						text = res.msg;
						this.mate_show(element, text,-40,10);
						this.btn_clock = 0;
					}
				}
			})
		},
    // 任务段位领取
    get_danGrading_award() {
			let element = ' .part .taskContent .task1 .taskbtn '
      let text = ''
      if (this.my_danGrading_balance < 0) {
        return
      }
      if (this.btn_clock) {
        return
      }
      var item = {
        balance: 0,
      }
      for (var i in this.m_s_p) {
        if (this.m_s_p[i].balance > 0) {
          item = this.m_s_p[i]
          break
        }
      }
      if (item.balance == 0) {
        return
      }

      this.btn_clock = 1
      _09game.g_t(item.packet_id, (res) => {
        text = ''
        if (res.code == 0) {
          text = '领取成功！'
          this.my_danGrading_balance = this.my_danGrading_balance - 1
          item.balance = item.balance - 1
          this.query_my_item_count()
          this.query_danGrading_baseData()
          this.btn_clock = 0
          this.mate_show(element, text, -40, 10)
        } else {
          this.btn_clock = 0
          text = res.info
          this.mate_show(element, text, -40, 10)
        }
      })
    },
    // 开通会员
    open_membership() {
      let element ='.pop .btns popbtn'
      _09game.q_d(
        'buy_goods',
        {
          token: this.token,
          goods_id: 900801,
          Count: 1,
          Price: 490,
        },
        (res) => {
          if (res.code == 0) {
            this.btn_clock = 0
            this.show_pay_result(4, '会员开通成功！', 1)
          } else {
            if (res.code == 14) {
              this.pay_jiubi = 490
              this.btn_clock = 0
              this.btype = 1
              this.buy()
            } else {
              this.mate_show(element, res.info, -40, 10)
            }
          }
        }
      )
    },
    u_h_i() {
      this.plus_flag = 1
      this.shengxia = 30
      this.p_s = 'bh'
      this.query_my_item_count()
      this.undate_add_btn()
    },
    touchmove(e) {
      let _this = this
      let offset = $('.pop .bar').offset().left
      let total = $('.pop .bar').width()
      var newX = Math.ceil(((e.touches[0].clientX - offset) / total) * 10000) / 100
      if (newX > 100) {
        newX = 100
      } else if (newX <= 0) {
        newX = 0
      }
      _this.slider.width = newX
      _this.c_f = Math.ceil((newX * _this.total_exploit) / 100 / 10) * 10
    },
    touchstart(e) {
      e.preventDefault()
      // console.log("开始位置======", e.touches[0].clientX);
    },
    touchend(e) {
      //  console.log(e);
    },
    // 打开各种大弹框的逻辑
    open_dialog(ps, item) {
      console.log
      if (ps == 'yc') {
        //去补领
        if (this.total_exploit <= 0) {
          return false
        }
        this.p_s = ps
        this.c_f = this.total_exploit
        this.slider.width = 100
        var begin,
          end = 0
        setTimeout(() => {
          // $('.pop .drag').mousemove(function(e){
          //     var offset = $(_this).offset().left
          //     console.log(offset);
          //     var oldX = e.pageX - offset
          //     begin = _this.slider.width
          //     _this.move(e);
          //     $(document).on('mousemove', move)
          //     $(document).on('mouseup', (e)=> {
          //         $(document).off('mousemove', move)
          //     })
          // })
        }, 50)
      } else if (ps == 'bh') {
        // 开通plus
        if (this.shengxia && !this.plus_flag) {
          // this.u_h_i()
          this.p_s = ps
        } else {
          this.p_s = ps
        }
      } else if (ps == 'prev') {
        // 预览特效
        this.p_s = ps
        this.videoName = item[0].name
        this.videoUrl = 'https://cdn.09game.com/resources/flv/' + item[0].id + '.mp4'
      } else {
        this.p_s = ps
      }
    },
    close_pop() {
      // document.onmousewheel = mouse
      if (this.p_s == 'l_reward') {
        this.prize_info = null
        this.is_shaking = false
        this.is_first = true
        this.btn_clock = 0
        clearTimeout(this.timer_openbox)
        this.timer_openbox = null
      } else if (this.p_s == 'turn') {
        if (this.btn_clock) {
          return false
        }
        this.btn_clock = 0
        this.$refs.myLucky.init()
      }
      this.choo_id = 0
      // this.zx_heroBaseData = []
      this.showspTip = false
      this.p_s = null
    },
    // 更新赛季经验按钮
    undate_add_btn() {
      for (var i in this.add_exploit_baseData) {
        var item = this.add_exploit_baseData[i]
        item.cn = ''
        if (this.duanWei) {
          //需要修改
          if (this.duanWei >= 900 && item.packet_id == 920234) {
            item.cn = 'get'
          } else if (this.duanWei >= 1000 && item.packet_id == 920236) {
            item.cn = 'get'
          } else if (this.duanWei >= 1100 && item.packet_id == 920238) {
            item.cn = 'get'
          } else if (this.duanWei >= 1200 && item.packet_id == 920240) {
            item.cn = 'get'
          }
        }
        if (item.count <= this.add_exploit_count && (item.packet_id != 920241 || (this.last_count > 0 && item.packet_id == 920241))) {
          item.cn = 'get'
        }
        for (var j in this.Changed_list) {
          if (this.Changed_list[j].item_id == item.packet_id && (item.packet_id != 920241)) {
            item.cn = 'over'
            break
          }

        if (this.last_count == 0 && item.packet_id == 920241) {
          item.cn = ''
          break
        }
        }
      }
    },
    buy() {
      let self = this
      if (this.btn_clock) {
        return false
      }
      this.btn_clock = 1
      this.$http
        .q_hd(
          'PubPay',
          'https://wx.pay.09game.com/WeChatPay/',
          {
            token: this.token,
            total_fee: Number(this.pay_jiubi),
          },
          true
        )
        .then((res) => {
          this.btn_clock = 0
          if (res.code == 1) {
            alert(res.msg)
          } else if (res.code == 0) {
            // console.log(res.data)
            self.payData = res.data
            if (typeof WeixinJSBridge == 'undefined') {
              if (document.addEventListener) {
                document.addEventListener('WeixinJSBridgeReady', self.onBridgeReady, false)
              } else if (document.attachEvent) {
                document.attachEvent('WeixinJSBridgeReady', self.onBridgeReady)
                document.attachEvent('onWeixinJSBridgeReady', self.onBridgeReady)
              }
            } else {
              self.onBridgeReady()
            }
          }
        })
    },

    onBridgeReady() {
      let self = this
      window.WeixinJSBridge.invoke(
        'getBrandWCPayRequest',
        {
          appId: this.payData.appId, //公众号名称，由商户传入 ok
          timeStamp: this.payData.timeStamp, //时间戳，自1970年以来的秒数 ok
          nonceStr: this.payData.nonceStr, //随机串
          package: this.payData.package,
          signType: 'MD5', //微信签名方式
          paySign: this.payData.paySign, //微信签名
        },
        function (res) {
          if (res.err_msg == 'get_brand_wcpay_request:ok') {
            // 使用以上方式判断前端返回,微信团队郑重提示：
            //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
            if (self.btype == 1) {
              self.open_membership()
            } else if (self.btype == 2) {
              self.confirm_retroactive()
            }
          } else {
            if (res.err_msg == 'get_brand_wcpay_request:cancel') {
              alert('取消支付！')
            } else if (res.err_msg == 'get_brand_wcpay_request:fail') {
              alert('支付失败！')
            } else {
              alert(res.err_msg)
            }
          }
        }
      )
    },

		mate_show(element, text, offsetTop,offsetLeft) {
			$('.mate-info').html(text);
			var width1 = $(element).width();
			var width = $('.mate-info').width()+44;
			var offWidth = (width1 - width) / 2;
			var top = $('.content').offset().top;
			var cssTop = $(element).offset().top - top + offsetTop;
			var cssLeft = $(element).offset().left + offWidth + offsetLeft;
			var css = {
				top: cssTop,
				left: cssLeft
			};
			if (this.timer) {
				clearTimeout(this.timer)
			}
			$('.mate-info').show().css(css);
			this.timer = setTimeout(function () {
				$('.mate-info').hide().html('');
			}, 3000)
		},
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/s34/index.scss';
</style>




// WEBPACK FOOTER //
// src/view/s34.vue